"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueOpeningHoursDto = exports.VenueOpeningHoursPeriodDto = exports.VenueOpeningHoursPeriodPointDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class VenueOpeningHoursPeriodPointDto {}
exports.VenueOpeningHoursPeriodPointDto = VenueOpeningHoursPeriodPointDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Day of week (0 = Sunday … 6 = Saturday, Google Places convention).'
}), __metadata("design:type", Number)], VenueOpeningHoursPeriodPointDto.prototype, "day", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueOpeningHoursPeriodPointDto.prototype, "hour", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueOpeningHoursPeriodPointDto.prototype, "minute", void 0);
class VenueOpeningHoursPeriodDto {}
exports.VenueOpeningHoursPeriodDto = VenueOpeningHoursPeriodDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueOpeningHoursPeriodPointDto
}), __metadata("design:type", VenueOpeningHoursPeriodPointDto)], VenueOpeningHoursPeriodDto.prototype, "open", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueOpeningHoursPeriodPointDto,
  required: false
}), __metadata("design:type", VenueOpeningHoursPeriodPointDto)], VenueOpeningHoursPeriodDto.prototype, "close", void 0);
class VenueOpeningHoursDto {}
exports.VenueOpeningHoursDto = VenueOpeningHoursDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: [VenueOpeningHoursPeriodDto]
}), __metadata("design:type", Array)], VenueOpeningHoursDto.prototype, "periods", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  type: [String],
  description: 'Human-readable lines, e.g. "Monday: 9:00 AM – 5:00 PM".'
}), __metadata("design:type", Array)], VenueOpeningHoursDto.prototype, "weekdayDescriptions", void 0);
//# sourceMappingURL=VenueOpeningHours.dto.js.map